import React from 'react'
import PropTypes from 'prop-types'
import exact from 'prop-types-exact'
import { IonButton, IonIcon, IonText } from '@ionic/react'
import { chevronBackOutline } from 'ionicons/icons'

const propTypes = {
  to: PropTypes.string,
  label: PropTypes.string,
}

function BackToSearchButton({
  to = '/work_orders/search',
  label = 'Back to Search',
}) {
  return (
    <div className="back-button-container">
      <IonButton color="clear" routerLink={to} routerDirection="back">
        <IonIcon slot="start" color="dark" icon={chevronBackOutline} />
        <IonText color="dark">{label}</IonText>
      </IonButton>
    </div>
  )
}

BackToSearchButton.propTypes = exact(propTypes)

export default React.memo(BackToSearchButton)
